import React from 'react';
import { useDrawer } from '@context/DrawerContext';
import DatePicker from './DatePicker';

export default function DatePickerDrawer() {
  const { closeDrawer } = useDrawer();

  return <DatePicker onCancelClick={closeDrawer} />;
}
